import type { HistoryPeriod } from './historyPeriod'

export const historyKeys = {
  all: ['history'] as const,
  page: (subscriberId: string, period: HistoryPeriod) =>
    ['history', subscriberId, period.from, period.to] as const,
} as const
